import { Ng2StateDeclaration, Transition } from '@uirouter/angular';

import {LoginShellComponent} from './login-shell.component';
import { ApplicationTypes, AuthService, DEFAULT_PORTAL_URL_SUBDIRECTORY, SessionService } from '@edl-development/edl-common';
import {EdlLoginComponent, EdlForgotPasswordComponent, EdlResetPasswordComponent} from '@edl-development/edl-auth'

export function onEnter(trans: Transition) {
    var sessionService: SessionService = trans.injector().get(SessionService);

    if (sessionService.isAuthenticated()) {
        const loggedInPortalUrl = sessionService?.PortalSettings?.URLSubdirectory || DEFAULT_PORTAL_URL_SUBDIRECTORY;
        return trans.router.stateService.target('authenticated.dashboard', { loggedInPortalUrl });
    }
}

export function resolvePasswordResetRequest (transition: Transition, authService: AuthService) {
    let params = transition.params();
    let token: string = params.token;

    return authService
        .validateResetToken(token)
        .toPromise();
}

export let LoginStates: Ng2StateDeclaration[] = [{
    name: 'public.login',
    url: '/login',
    views: {
        'content@public': {
            component: LoginShellComponent
        },
        'login-content@public.login': {
            component: EdlLoginComponent
        }
    },
    resolve: [{
      token: 'componentHeader',
      deps: [],
      resolveFn: () => 'Login to Comply'
    },{
      token: 'AppID',
      deps: [],
      resolveFn: () => ApplicationTypes.EDL_COMPLY
    },{
      token: 'postAuthState',
      deps: [],
      resolveFn: () => 'authenticated.dashboard'

    }
    ],
    onEnter
}, {
    name: 'public.forgot-password',
    url: '/forgot-password',
    views: {
        'content@public': {
            component: LoginShellComponent
        },
        'login-content@public.forgot-password': {
            component: EdlForgotPasswordComponent
        }
    },
    resolve: [{
      token: 'appId',
      deps: [],
      resolveFn: () => ApplicationTypes.EDL_COMPLY
    }]
}, {
    name: 'public.reset-password',
    url: '/reset-password/:token',
    views: {
        'content@public': {
            component: LoginShellComponent
        },
        'login-content@public.reset-password': {
            component: EdlResetPasswordComponent
        }
    },
    resolve: [{
        token: 'passwordResetRequest',
        deps: [Transition, AuthService],
        resolveFn: resolvePasswordResetRequest
    }]
}]
